module.exports = __webpack_public_path__ + "static/media/lock.c5d8595a.svg";